/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LessorCompanyChangePasswordViewModel
 */
export interface LessorCompanyChangePasswordViewModel {
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyChangePasswordViewModel
     */
    otpCode: string;
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyChangePasswordViewModel
     */
    password: string;
}

export function LessorCompanyChangePasswordViewModelFromJSON(json: any): LessorCompanyChangePasswordViewModel {
    return LessorCompanyChangePasswordViewModelFromJSONTyped(json, false);
}

export function LessorCompanyChangePasswordViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessorCompanyChangePasswordViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otpCode': json['otpCode'],
        'password': json['password'],
    };
}

export function LessorCompanyChangePasswordViewModelToJSON(value?: LessorCompanyChangePasswordViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'otpCode': value.otpCode,
        'password': value.password,
    };
}

